import ReportBase from 'app/models/report_base';

export default ReportBase.extend({
  reportType: 'fulfillment_order',
});



// WEBPACK FOOTER //
// ./app/models/fulfillment_order_report.js